import { getPagePath, trans } from '@spotahome/soyuz/client';

import LandingSocialBannerSection from '@spotahome/landings-common/src/components/LandingSocialBannerSection';

import HeartLockIcon from './Icons/HeartLockIcon';

const Social = () => {
  return (
    <LandingSocialBannerSection
      title={trans('tenant_guarantees.social.title')}
      cta={{
        url: getPagePath('landing'),
        text: trans('tenant_guarantees.social.cta')
      }}
      renderIcon={() => <HeartLockIcon size={80} />}
    />
  );
};

export default Social;
